import React from 'react';

const Footer = () => {
  return (
    <footer className="py-6 bg-gray-800 text-white">
      <div className="container mx-auto text-center">
        {/* <div className="mt-4 space-x-4">
          <a href="https://facebook.com" className="hover:underline">Facebook</a>
          <a href="https://twitter.com" className="hover:underline">Twitter</a>
          <a href="https://instagram.com" className="hover:underline">Instagram</a>
        </div> */}
      </div>
    </footer>
  );
};

export default Footer;
